<template>
	<div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<order-status :order="order"/>
			</div>
		</div>

		<div>
			<div class="vx-row">
				<div class="vx-col w-9/12">
					<div class="vx-row">
						<div class="vx-col w-4/12">
							<info :order="order" />
						</div>

						<div class="vx-col w-4/12">
							<shipping :order="order" :dymo-printer="dymoPrinter" />
						</div>

						<div class="vx-col w-4/12">
							<billing :order="order" :dymo-printer="dymoPrinter" />
						</div>
					</div>

					<div class="vx-row" v-if="order.order.status === 3">
						<div class="vx-col w-full mt-5">
							<send-info :order="order" />
						</div>
					</div>
				</div>

				<div class="vx-col w-3/12">
					<div class="mt-5 mb-5">
						<downloadpackingslib :order_id="order.order.id"></downloadpackingslib>
					</div>
					<div class="mt-5 mb-5">
						<downloadlabelpdfs :order="order"></downloadlabelpdfs>
					</div>

					<invoice-card :order="order"/>
				</div>

			</div>
			<div class="vx-row mt-5">
				<div class="vx-col w-full">
					<vx-card title="Producten" class="text-md" noShadow cardBorder>
						<product :product="product" :order="order" :index="index" :key="index" v-for="(product, index) in this.order.items" />
					</vx-card>
				</div>
			</div>
			<div class="vx-row mt-5">
				<div class="vx-col w-full">
					<totals :order="order" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import product from './product';
import info from './info';
import shipping from './shipping';
import billing from './billing'
import totals from './totals'
import sendInfo from './sendInfo';
import downloadpackingslib from './downloadpackingslib';
import Downloadlabelpdfs from "./downloadlabelpdfs.vue";
import dymoPrinter from '@/services/dymo/dymoPrinter';
import {mapGetters} from 'vuex';
import InvoiceCard from '@/views/orderDetails/invoice/invoiceCard';
import OrderStatus from '@/views/orders/components/status';

export default {
	components: {
		Downloadlabelpdfs,
		OrderStatus,
		InvoiceCard,
		product,
		info,
		shipping,
		billing,
		totals,
		sendInfo,
		downloadpackingslib,
	},
	data() {
		return {
			totalTransactionFee: 0,
			totalMarge: 0,
		}
	},
	props: {
		order: {
			type: Object,
			required: true,
		},
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
	computed: {
		...mapGetters({
			isEboekhoudenEnabled: 'dashboard/eboekhoudenEnabled'
		}),
	},
	mounted() {
		this.calculateTotalTransactionFee();
	},
	methods: {
		copyBolOrderId() {
			this.$copyText(this.order.order.type_id_visible).then(result => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Dit bestelnummer is succesvol naar je klembord gekopieerd!',
					color: 'success',
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het kopiëren is mislukt!',
					color: 'danger',
				});
			});
		},
		calculateTotalTransactionFee() {
			let totalTransactionFee = 0;
			this.order.items.forEach(item => {
				totalTransactionFee += item.unit_commission;
			});
		}
	}
}
</script>
